export { zoneColors, type ZoneColorKey } from '@trainme/api/client';
